// extracted by mini-css-extract-plugin
module.exports = {"leisurePanel":"styles_leisurePanel__FVn74","leisureCollapse":"styles_leisureCollapse__DFyaO","leisureHeader":"styles_leisureHeader__Jgd2e"};